import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { ContentAnalyticsComponent } from "./content-analytics/content-analytics.component";
import { AnalyticsComponent } from "../analyics/analytics.component";
import { UserDashboardComponent } from "./user-dashboard.component";
import { GiftedfundsComponent } from "./giftedfunds/giftedfunds.component";
import { ConsultationsComponent } from "./consultations/consultations.component";
import { ScheduleconsultationsComponent } from "./scheduleconsultations/scheduleconsultations.component";
import { TransferedContentApprovalsComponent } from "./transfered-content-approvals/transfered-content-approvals.component";
import { AccessRequestsComponent } from "./access-requests/access-requests.component";
import { IncomingApprovalsComponent } from "./transfered-content-approvals/incoming-approvals.component";
import { OutgoingApprovalsComponent } from "./transfered-content-approvals/outgoing-approvals.component";
import { FlowReviewsComponent } from "./flow-reviews/flow-reviews.component";
import { ContentApprovalsComponent } from "./content-approvals/content-approvals.component";
import { OrgContentComponent } from "./org-content/org-content.component";
import { TaskModeReportsComponent } from "./task-mode-reports/task-mode-reports.component";
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: "enabled",
  anchorScrolling: "enabled",
  scrollOffset: [0, 464],
};

const routes: Routes = [
  {
    path: "",
    component: UserDashboardComponent,
    children: [
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        component: DashboardComponent,
      },
      {
        path: "content-analytics",
        component: ContentAnalyticsComponent,
      },
      {
        path: "gift",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "my-consultation",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "pending-consultations",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "outgoing-tranfer-approvals",
        component: OutgoingApprovalsComponent,
      },
      {
        path: "incoming-tranfer-approvals",
        component: IncomingApprovalsComponent,
      },
      {
        path: "access-requests",
        component: AccessRequestsComponent,
      },
      {
        path: "guide-reviews",
        component: FlowReviewsComponent,
      },
      {
        path: "flow-reviews",
        redirectTo: "guide-reviews",
        pathMatch: "full",
      },
      {
        path: "content-approvals",
        component: ContentApprovalsComponent,
      },
      {
        path: "org-content",
        component: OrgContentComponent,
      },
      {
        path: "task-mode-reports",
        component: TaskModeReportsComponent,
      },
      {
        path: "question-responses",
        redirectTo: "/user-dashboard/task-mode-reports?tab=responses",
        pathMatch: "full",
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserDashboardRoutingModule {}
